import { render } from "./UnboxHeaderBox.vue?vue&type=template&id=38e3a243&scoped=true"
import script from "./UnboxHeaderBox.vue?vue&type=script&lang=js"
export * from "./UnboxHeaderBox.vue?vue&type=script&lang=js"

import "./UnboxHeaderBox.vue?vue&type=style&index=0&id=38e3a243&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38e3a243"]])

export default __exports__